/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import {
  Modal,
  Table,
  Button,
} from 'react-bootstrap';
import Select from 'loracoms/Select';
import Checkbox from 'loracoms/Checkbox';
import ShowIf from 'loracoms/ShowIf';
import TablePager from 'loracoms/TablePager';
import SearchInput from 'loracoms/SearchInput';
import LoadingTable from 'loracoms/LoadingTable';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import callAPI from '@/api/callAPI';
import { parseContent, kSFOptions } from '../util';
import styles from './styles.scss';

const kOffset = 10;
const kInitalState = {
  list: [],
  reset: 0,
  search: '',
  more: false,
  checked: [],
  submitStatus: '',
  errorMsg: '',
};

const propTypes = {
  intl: intlShape.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  addSucceed: PropTypes.func.isRequired,
  typesJSON: PropTypes.object.isRequired,
  deleteNode: PropTypes.object.isRequired,
  networkDetail: PropTypes.object.isRequired,
  gatewayOptions: PropTypes.array.isRequired,
};

class CreateNode extends React.Component {
  constructor(props) {
    super(props);
    const { types } = parseContent(props.typesJSON);
    this.state = {
      ...kInitalState,
      options: types.nodetypes ?
        _.map(types.nodetypes, n => ({ value: n.type, label: n.type })) : [],
      list: '',
      status: '',
      appOpts: [],
      selectedApp: '',
      show: props.show,
      gatewayOptions: props.gatewayOptions,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.node.create');
    this.mark = 0;
    this.list = [];
    this.types = types;
    this.allNodes = [];
    this.addQueue = [];
    this.deleteNode = props.deleteNode;
    this.networkDetail = props.networkDetail;
    this.sfOptions = _.concat([{ label: this.intlMsg.msg('sf.default'), value: null }], kSFOptions);
    this.onHide = this.onHide.bind(this);
    this.loadApps = this.loadApps.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.allChecked = this.allChecked.bind(this);
    this.onNextPage = this.onNextPage.bind(this);
    this.onPrevPage = this.onPrevPage.bind(this);
  }

  componentDidMount() {
    // this.loadAllNodes(this.loadApps);
    this.loadApps();
  }

  componentWillReceiveProps(nextProps) {
    const { show, networkDetail, typesJSON, gatewayOptions } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
      if (show) {
        this.loadAltNodes();
      }
    }
    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.networkDetail = networkDetail;
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      const { types } = parseContent(typesJSON);
      const options = types.nodetypes ?
        _.map(types.nodetypes, n => ({ value: n.type, label: n.type })) : [];
      this.types = types;
      this.setState({ options });
    }
    if (!_.isEqual(gatewayOptions, this.props.gatewayOptions)) {
      this.setState({ gatewayOptions });
    }
  }

  onChangeApp(selectedApp) {
    if (selectedApp === this.state.selectedApp) return;
    this.list = [];
    this.mark = 0;
    this.setState({ reset: new Date().valueOf(), selectedApp, checked: [] }, this.loadAltNodes);
  }

  onSearch(e) {
    const search = _.trim(e.target.value);
    this.mark = 0;
    this.setState({ search, reset: new Date(), checked: [] }, this.loadAltNodes);
  }

  onChangeRemark(e, { id }) {
    const memo = e.target.value;
    if (this.remarkTimer) {
      clearTimeout(this.remarkTimer);
    }

    this.remarkTimer = _.delay(() => {
      const list = _.map(this.state.list, (l) => {
        if (l.id === id) {
          return { ...l, memo };
        }
        return l;
      });
      this.setState({ list });
    }, 250);
  }

  onSelectNodeType(typ, { id }) {
    if (!this.types.nodetypes) return;

    const services = _.find(this.types.nodetypes, n => n.type === typ).services;
    if (this.nodeTimer) {
      clearTimeout(this.nodeTimer);
    }
    this.nodeTimer = _.delay(() => {
      const list = _.map(this.state.list, (l) => {
        if (l.id === id) {
          return { ...l, typ, services };
        }
        return l;
      });
      this.setState({ list, errorMsg: '' });
    }, 250);
  }

  onSelectSF(sf, { id }) {
    if (this.sfTimer) {
      clearTimeout(this.sfTimer);
    }

    this.sfTimer = _.delay(() => {
      const list = _.map(this.state.list, (l) => {
        if (l.id === id) {
          return { ...l, sf };
        }
        return l;
      });
      this.setState({ list, errorMsg: '' });
    }, 250);
  }

  onSelectGateway(h, { id }) {
    if (this.gtwTimer) {
      clearTimeout(this.gtwTimer);
    }

    this.gtwTimer = _.delay(() => {
      const list = _.map(this.state.list, (l) => {
        if (l.id === id) {
          return { ...l, home: h };
        }
        return l;
      });
      this.setState({ list });
    }, 250);
  }

  onHide() {
    this.mark = 0;
    this.setState({ ...kInitalState, reset: new Date().valueOf() });
    this.props.onHide();
  }

  onSubmit() {
    const { checked, list } = this.state;
    if (!checked.length) return;

    const { id: netw } = this.networkDetail.data || {};

    let nodes = _.map(checked, (c) => {
      const n = _.find(list, l => l.id === c.id);
      const memo = n ? _.trim(n.memo) : c.memo;
      const name = n ? n.name : '';
      const appeui = n ? n.appeui : null;
      return {
        netw,
        id: c.id,
        typ: n ? n.typ : '',
        services: n ? n.services : [],
        sf: n ? n.sf : null,
        memo: JSON.stringify({ remark: memo, name, appeui }),
        home: n ? n.home : null,
      };
    });
    nodes = _.filter(nodes, n => n.typ && n.services);

    if (!nodes.length) {
      this.setState({ errorMsg: 'FE_NO_CHECKED_NODES' });
      return;
    }

    this.setState({ submitStatus: 'pending' });
    this.addQueue = _.concat(this.addQueue, nodes);
    const addFunc = () => {
      if (this.addQueue.length > 0) {
        const node = this.addQueue.pop();
        callAPI({
          method: 'POST',
          endpoint: '/tdmng/nodes',
          body: { ...node },
        }).then(() => {
          _.find(list, d => d.id === node.id).added = true;
          this.setState({ list });
          addFunc();
        }).catch(() => {});
      } else {
        this.setState({ submitStatus: 'success' });

        _.delay(() => {
          this.props.addSucceed();
          this.onHide();
        }, 250);
      }
    };
    addFunc();
  }

  onNextPage() {
    this.mark += kOffset;
    this.setState({ checked: [] });
    this.loadAltNodes();
  }

  onPrevPage(m) {
    this.mark = m || 0;
    this.setState({ checked: [] });
    this.loadAltNodes();
  }

  loadApps() {
    callAPI({
      endpoint: '/lora/applications?pageSize=20',
    }).then(({ list }) => {
      const appOpts = _.map(list, l => ({ label: l.name, value: l.appeui }));
      this.setState({ appOpts });
      if (list[0]) {
        this.setState({ selectedApp: list[0].appeui }, this.loadAltNodes);
      }
    }).catch(() => {});
  }

  loadAltNodes() {
    const { selectedApp, search } = this.state;

    callAPI({
      endpoint: '/tdmng/alt/nodes',
      query: { appeui: selectedApp, offset: this.mark, limit: kOffset, q: search },
      method: 'GET',
    }).then((res) => {
      const { more, mark, list } = res;
      this.setState({ list, mark, more, status: 'success' });
    }).catch(() => {});
  }

  isChecked(d) {
    const { checked } = this.state;
    return _.some(checked, { id: d.id });
  }

  toggleCheck(d) {
    let { checked } = this.state;
    if (this.isChecked(d)) {
      checked = _.filter(checked, c => c.id !== d.id);
    } else {
      checked = _.concat(checked, [d]);
    }
    this.setState({ checked });
  }

  allChecked() {
    const { checked, list } = this.state;
    return (
      list.length > 0 &&
      checked.length === list.length
    );
  }

  toggleCheckAll() {
    this.setState({
      checked: this.allChecked() ? [] : this.state.list,
    });
  }

  render() {
    const {
      show,
      list,
      more,
      mark,
      reset,
      search,
      status,
      checked,
      appOpts,
      options,
      errorMsg,
      selectedApp,
      submitStatus,
      gatewayOptions,
    } = this.state;
    const disabled = submitStatus === 'pending';

    let content = null;
    const rows = Math.max(1, list.length);
    const thead = (
      <thead>
        <tr>
          <th>
            <Checkbox
              id="allAppNodes"
              disabled={disabled}
              checked={this.allChecked()}
              onChange={e => this.toggleCheckAll(e)}
            />
          </th>
          <th>{this.intlMsg.msg('name')}</th>
          <th>DevEUI</th>
          <th>{this.intlMsg.msg('nodetype')}</th>
          <th>SF</th>
          <td>{this.intlMsg.msg('gateway.bind')}</td>
          <th>{this.intlMsg.msg('remark')}</th>
        </tr>
      </thead>
    );
    if (status === 'success') {
      content = (
        <Table className="aisz-table-light" striped>
          {thead}
          <tbody>
            {_.map(list, l => (
              <tr key={l.id} className={l.added ? styles.added : ''}>
                <td>
                  <Checkbox
                    id={l.id}
                    disabled={disabled}
                    checked={this.isChecked(l)}
                    onChange={() => this.toggleCheck(l)}
                  />
                </td>
                <td>{l.name}</td>
                <td>{normalizeDevEUI(l.deveui)}</td>
                <td>
                  <Select
                    options={options}
                    value={l.typ}
                    onChange={s => this.onSelectNodeType(s, l)}
                  />
                </td>
                <td>
                  <Select
                    options={this.sfOptions}
                    value={l.sf}
                    onChange={s => this.onSelectSF(s, l)}
                  />
                </td>
                <td>
                  <Select
                    options={gatewayOptions}
                    value={l.home}
                    onChange={h => this.onSelectGateway(h, l)}
                  />
                </td>
                <td>
                  <input
                    className={styles.memo}
                    onChange={e => this.onChangeRemark(e, l)}
                    placeholder={this.intlMsg.msg('remark.placeholder')}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      );
    } else {
      content = (
        <LoadingTable
          className="aisz-table-light"
          striped
          bordered
          rows={rows}
          cols={7}
        >
          {thead}
        </LoadingTable>
      );
    }
    return (
      <Modal
        bsClass="aisz-modal-light"
        backdrop="static"
        show={show}
        onHide={this.onHide}
        className={styles.create}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('header')}
        </Modal.Header>
        <Modal.Body>
          <div className={styles.selector}>
            <div>
              <span className={styles.label}>{this.intlMsg.msg('apps')}</span>
              <Select
                options={appOpts}
                value={selectedApp}
                onChange={s => this.onChangeApp(s)}
              />
            </div>
            <div>
              <SearchInput
                onChange={this.onSearch}
                value={search}
                placeholder={this.intlMsg.msg('search.placeholder')}
              />
            </div>
          </div>
          {content}
          <ShowIf if={list.length > 0}>
            <div className={styles.pager}>
              <TablePager
                status={status}
                mark={mark}
                more={more}
                reset={reset}
                onPrev={this.onPrevPage}
                onNext={this.onNextPage}
              />
            </div>
          </ShowIf>
        </Modal.Body>
        <Modal.Footer>
          {errorMsg &&
            <span className={styles.error}>
              <i className="fa fa-info-circle" />&nbsp;
              {this.intlMsg.msg(errorMsg)}
            </span>
          }
          <Button
            bsStyle="aisz-default"
            onClick={this.onHide}
            className={styles.white}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
          <Button
            bsStyle="aisz-success"
            onClick={this.onSubmit}
            disabled={submitStatus === 'pending' || _.isEmpty(checked)}
          >
            {submitStatus === 'pending' && <i className="fa fa-spin fa-spinner m-r-s" />}
            {this.intlMsg.msg('confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

CreateNode.propTypes = propTypes;

const mapStateToProps = state => ({
  typesJSON: state.tdm.setting,
  networkDetail: state.tdm.getNetwork,
});

export default connect(mapStateToProps)(injectIntl(CreateNode));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Node/CreateNode.jsx